import ProfileContent from 'src/components/blocks/profile-content'
import './style.scss'

const Me = () => {
  return <ProfileContent />
}

export default Me
